module.exports = __webpack_public_path__ + "img/img39.8f497214.svg";